import { Card, CardContent } from '@shared/ui';
import type React from 'react';
import { useNavigate } from 'react-router-dom';
import SlackDetail from './SlackDetail';

const SlackSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <SlackDetail
          back={() => navigate('/settings/integrations')}
          iconSrc={'https://a.slack-edge.com/80588/marketing/img/meta/favicon-32.png'}
        />
      </CardContent>
    </Card>
  );
};

export default SlackSettingsPage;
